import React from 'react';

export const IconPlayBlack = () => {
  return (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.35261 4.98279C6.60153 4.55559 5.66699 5.09539 5.66699 5.95644V17.0437C5.66699 17.9047 6.60153 18.4445 7.35261 18.0173L17.0993 12.4736C17.8562 12.0432 17.8562 10.9569 17.0993 10.5265L7.35261 4.98279Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.35261 4.98279C6.60153 4.55559 5.66699 5.09539 5.66699 5.95644V17.0437C5.66699 17.9047 6.60153 18.4445 7.35261 18.0173L17.0993 12.4736C17.8562 12.0432 17.8562 10.9569 17.0993 10.5265L7.35261 4.98279Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
